"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = stableStringify;
const json_stable_stringify_1 = __importDefault(require("json-stable-stringify"));
function stableStringify(o) {
    var _a;
    return (_a = (0, json_stable_stringify_1.default)(o)) !== null && _a !== void 0 ? _a : "null";
}
//# sourceMappingURL=stableStringify.js.map